import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const cardVariants = cva(
  "rounded-2xl transition-all duration-300",
  {
    variants: {
      variant: {
        light: "bg-white border border-gray-100 shadow-[0_1px_3px_rgba(0,0,0,0.04)]",
        lightHover: "bg-white border border-gray-100 shadow-[0_1px_3px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] hover:border-gray-200 hover:-translate-y-0.5",
        elevated: "bg-[#13082a] border border-white/[0.06] shadow-2xl shadow-black/40 rounded-[2rem]",
        panel: "bg-[#f7f5fa] border-0",
        muted: "bg-[#faf8fc] border border-gray-100",
        dark: "bg-white/[0.04] border border-white/[0.08]",
        darkHover: "bg-white/[0.02] border border-white/[0.06] hover:bg-white/[0.04] hover:border-white/[0.1]",
        outline: "border border-gray-100 bg-transparent",
      },
      padding: {
        none: "",
        sm: "p-5",
        default: "p-7 md:p-8",
        lg: "p-8 md:p-12",
        xl: "p-8 md:p-14",
      },
    },
    defaultVariants: {
      variant: "light",
      padding: "default",
    },
  }
)

export interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, variant, padding, ...props }, ref) => (
    <div ref={ref} className={cn(cardVariants({ variant, padding, className }))} {...props} />
  )
)
Card.displayName = "Card"

export { Card, cardVariants }
